import React from 'react';
import MypagePaymentWrapper from 'components/MypagePaymentWrapper/MypagePaymentWrapper';

export default function MypagePaymentContainer() {
    return (
        <MypagePaymentWrapper />
    )
}
